<template>
  <div class="errPage-container">
    <div class="errImgBox">
      <img :src="errImg" alt="">
    </div>
    <p class="errTips">很抱歉，访问的页面不存在</p>
  </div>
</template>

<script>
import errImg from '@/assets/401_images/errImg401.png'

export default {
  name: 'Page401',
  data() {
    return {
      errImg:errImg,
    }
  },
  methods: {
   
  }
}
</script>

<style scoped>
.errPage-container {
    height: 100%;
    width: 100%;
    text-align: center;
  }

  .errImgBox{
     padding-top: 113px;
  }

  .errImgBox img{
     width: 181px;
     height:161px;
  } 

  .errTips{
    margin-top: 10px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/errorPage/401.vue